//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import { postFakeProfile, postJwtProfile } from "../../../helpers/auth_helper";
import { Axios } from "api/axios";

// action
import { profileSuccess, profileError, resetProfileFlagChange, setUserProfile, setProfileLoading } from "./reducer";

export const editProfile = (user: any) => async (dispatch: any) => {
    const fireBaseBackend = getFirebaseBackend();
    try {
        let response;

        if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
            response = fireBaseBackend.editProfileAPI(
                user.username,
                user.idx
            );

        } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
            response = postJwtProfile(
                {
                    username: user.username,
                    idx: user.idx,
                }
            );

        } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
            response = postFakeProfile(user);
        }

        const data = await response;

        if (data) {
            dispatch(profileSuccess(data));
        }

    } catch (error) {
        dispatch(profileError(error));
    }
};

export const resetProfileFlag = () => {
    try {
        const response = resetProfileFlagChange();
        return response;
    } catch (error) {
        return error;
    }
};

// Fetch user profile data
export const fetchUserProfile = (userId: string) => async (dispatch: any) => {
    try {
        dispatch(setProfileLoading(true));
        const response = await Axios.get(`users/users/${userId}/`);
        if (response.status === 200 && response.data?.data) {
            // Exclude permissions from the user data
            const { permissions, ...userData } = response.data.data;
            dispatch(setUserProfile(userData));
            return userData;
        } else {
            dispatch(profileError('Failed to fetch user profile'));
            dispatch(setProfileLoading(false));
            return Promise.reject('Failed to fetch user profile');
        }
    } catch (error: any) {
        const errorMsg = error?.response?.data?.error || error?.response?.data?.message || 'Failed to fetch user profile';
        dispatch(profileError(errorMsg));
        dispatch(setProfileLoading(false));
        return Promise.reject(errorMsg);
    }
};